import { ReactNode } from 'react';
import { useTranslation } from '@frontend/i18n';
import { useSlidePanelShallowStore } from '@frontend/slide-panel';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { CallDetailsContext } from '../types';
import { ScreenBase } from './types';

export const PanelHeader = ({ children }: { children: ReactNode } & ScreenBase) => {
  const { setShow } = useSlidePanelShallowStore<CallDetailsContext>('setShow', 'context', 'show');
  const { t } = useTranslation('calls');

  return (
    <header
      style={{
        display: 'grid',
        gridTemplateRows: '48px auto',
      }}
    >
      <div
        style={{
          display: 'grid',
          borderBottom: `1px solid ${theme.colors.neutral20}`,
          alignItems: 'center',
        }}
      >
        <Button
          css={{
            justifySelf: 'end',
          }}
          variant='secondary'
          label={t('Close panel')}
          iconName='x'
          size='large'
          onClick={() => {
            setShow(false);
          }}
        />
      </div>
      <div
        style={{
          padding: theme.spacing(2, 3),
          borderBottom: `1px solid ${theme.colors.neutral20}`,
        }}
      >
        {children}
      </div>
    </header>
  );
};

export const ScreenLayout = ({
  setScreen,
  render,
}: {
  render: (props: ScreenBase) => ReactNode;
} & ScreenBase) => {
  return (
    <div
      style={{
        height: '100%',
        padding: theme.spacing(3),
      }}
    >
      {render({ setScreen })}
    </div>
  );
};
